import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import { Container, Col } from 'react-bootstrap';
import PromotionsPage from '../../../modules/promotion/PromotionsPage';

const Promotion = () => {
  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Promotion', link: '/promotion-list', active: true },
  ];

  return (
    <>
      <div className="bread-crumb">
        <Container>
          <Col md={8}>
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>

      <PromotionsPage routeBase="/promotion-list" />
    </>
  );
};

export default Promotion;